import angular from 'angular';

angular.module('cloudX').directive('cxOptionXedit', function() {
  return {
    restrict: 'E',
    template:
      '<a href="" editable-select="value" onbeforesave="beforeSave({newValue:$data})" onaftersave="afterSave({newValue:$data})" e-ng-options="item.id as item.label for item in ' +
      'options | orderBy:\'label\'"> <span ng-show="value || value===0" >{{value | translateList:option}}</span> ' +
      '<i class="glyphicon glyphicon-pencil" ng-show="!value && value!==0"></i> </a>',
    scope: {
      value: '=data',
      option: '@',
      beforeSave: '&?',
      afterSave: '&?',
    },
    controller: [
      '$scope',
      '$rootScope',
      '$filter',
      'optionsSvc',
      function($scope, $rootScope, $filter, optionsSvc) {
        if (angular.isUndefined($scope.beforeSave)) $scope.beforeSave = angular.noop;
        if (angular.isUndefined($scope.afterSave)) $scope.afterSave = angular.noop;

        function mapOptions() {
          var options = optionsSvc.getOptions($scope.option) || [];
          $scope.options = options.map(function(val) {
            return {
              id: val,
              label: $filter('translateList')(val, $scope.option, val),
            };
          });
        }
        mapOptions();
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);
      },
    ],
  };
});
